export default __webpack_public_path__ + "static/media/Hack-o-relay-removebg-preview.16a4d71f.png";